import React from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Icon extends React.Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    nameSpace: PropTypes.string,
    nameSpaceFallbacks: PropTypes.array,
    className: PropTypes.string,
  };

  static defaultProps = {
    nameSpace: undefined,
    nameSpaceFallbacks: ['icon-1c', 'fa'],
    className: undefined,
  };

  render() {
    const { icon, nameSpaceFallbacks, nameSpace, className, ...props } = this.props;

    let ns = nameSpace;

    if (isUndefined(ns)) {
      ns = nameSpaceFallbacks.find(fb => !!styles[`${fb}-${icon}`]);
    }

    const iconClasses = clx(
      'icon',
      {
        [ns]: ns,
        [`${ns}-${icon}`]: ns,
      },
      className
    );

    return <i className={iconClasses} {...props} />;
  }
}
